module.exports = __webpack_public_path__ + "static/media/not-serious-woman.148a0200.svg";